import { Box, Dialog, DialogContent } from "@mui/material"
import { BoxFC } from "components/BoxCustom"
import PaperComponent from "components/PaperComponent"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import React, {  useContext, useEffect, useMemo, useState } from "react"
import { addIdForDataGrid } from "utils"
import { detailColumns } from "./columns"
import { addSumRow, getSumColorClassName, sxSumColorClass } from "utils/highlightSumColor"
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand"
import { branchApiNm } from "branch/constant/branchApiNm"

const BasicReportDialog = ({ filter, dialogOpen, setDialogOpen }) => {

  const { ax } = useContext(GlobalStateContext)
  const [dataTable, setDataTable] = useState([])

  const modDataTable = useMemo(()=>{
    return addSumRow({
      dataTable: dataTable, 
      sumColNms: [ "NumJo", "DrvFixCost", "TripAmnt", "CostAmnt", "OprTotal", "InvOwnRcptAmnt", "InvCusRcptAmnt"
        , "InvTotal", "Profit"],
      sumColTotal: "DrvNm"
    })
  }, [dataTable])

  useEffect(() => {
    if (dialogOpen) {
      ax.post(branchApiNm.getMonthlyTruckReport, filter).then(value => {
        if (value.data) {
          setDataTable(addIdForDataGrid(value.data, "JobOrdId"))
        }
      })
    }

  }, [dialogOpen, ax, filter])

  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='xl'
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title={"รายละเอียด"}
        onDeleteClick={null}
      />
      <DialogContent>
        <BoxFC pt={2} >
          <Box height={600} sx={sxSumColorClass}>
            <DataGridCellExpand
              hideFooter
              rows={modDataTable}
              columns={detailColumns}
              getRowClassName={getSumColorClassName}
              experimentalFeatures={{ rowPinning: true }}
              pinnedRows={{ bottom: [modDataTable.find(row => row.id === 0)] }}
            />
          </Box>
        </BoxFC>
      </DialogContent>
      <DialogFooter okText={""}
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={null} />
    </Dialog>
  )
}

export default React.memo(BasicReportDialog)